module.exports = __webpack_public_path__ + "img/rimacautomobili-4.a58e0603.jpg";